/*
 *
 * App constants
 *
 */
import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/App';

export const CHANGE_CURRENT_PROJECT_START = `${prefix}/CHANGE_CURRENT_PROJECT_START`;
export const CHANGE_CURRENT_PROJECT_SUCCESS = `${prefix}/CHANGE_CURRENT_PROJECT_SUCCESS`;
export const GET_TEAMS_ONLY_TOKEN = defineApiActionTypes(`${prefix}/GET_TEAMS_ONLY_TOKEN`);
